import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { db } from "../firebase";
import { collection, onSnapshot, query, where } from "firebase/firestore";
import { useAuth } from "../contexts/AuthContext";
import dayjs from "dayjs";
import { MovieType } from "./movies";

const History: React.FC = () => {
  const { user } = useAuth();
  const [movies, setMovies] = useState<MovieType[]>([]);

  useEffect(() => {
    if (!user) return;
    const collectionRef = collection(db, "movies");
    const archivedQuery = query(collectionRef, where("status", "==", "archived"));
    const unsubscribe = onSnapshot(archivedQuery, (snapshot) => {
      const documents = snapshot.docs.map((doc) => {
        const data = doc.data();
        return {
          id: doc.id,
          name: data.name,
          details: data.details,
          status: data.status,
          amount: data.amount,
          goal: data.goal,
          date: data.date ? dayjs(data.date) : undefined,
          description: data.description,
          pseudo: data.pseudo,
          image: data.image,
          detailsProj: data.detailsProj,
        } as MovieType;
      });

      documents.sort((a, b) => {
        if (a.date && b.date) return b.date.unix() - a.date.unix();
        if (a.date) return -1;
        if (b.date) return 1;
        return 0;
      });

      setMovies(documents);
    });

    return () => unsubscribe();
  }, [user]);

  return (
    <div className="min-h-screen flex flex-col p-3 md:p-6 gap-4">
      <Link to="/" className="text-xs underline">← Retour</Link>
      <h1>Historique</h1>
      {movies.length === 0 && (
        <p className="italic text-gray-400">Aucun film archivé pour le moment.</p>
      )}
      {movies.map((movie) => (
        <div key={movie.id} className="flex flex-row gap-3">
          {movie.image && (
            <img className="w-24 h-auto object-cover" src={movie.image} alt={movie.name} />
          )}
          <div className="flex flex-col">
            <div className="flex flex-wrap">
              <b className="whitespace-nowrap mr-1">{movie.name}</b>
              {movie.details && <p className="px-1 italic">/</p>}
              <p className="italic">{movie.details}</p>
            </div>
            {movie.date && <p>{movie.date.format("DD/MM/YYYY")}</p>}
            {movie.pseudo && <p className="text-gray-400 text-sm">{movie.pseudo}</p>}
          </div>
        </div>
      ))}
    </div>
  );
};

export default History;
